import React from 'react';
import { Layout } from 'react-admin';
import MyAppBar from '../frame/MyAppBar'
import MyMenu from '../frame/MyMenu'

const MyLayout = (props) => <Layout {...props} appBar={MyAppBar} menu={MyMenu} />;

export default MyLayout;